import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthorizationGuardService} from '@westjetairlines/wjesd-oauth2-library';
import {SummaryComponent} from './summary.component';
import {Roles} from '../shared/models/roles';

const summaryWaiverRoutes: Routes = [
  {
    path: 'waivers/:id/summary',
    component: SummaryComponent,
    canActivate: [AuthorizationGuardService],
    data: { roles: [Roles.WaiversAdmin] }
  }
];

const summaryFavorRoutes: Routes = [
  {
    path: 'favours/:id/summary',
    component: SummaryComponent,
    canActivate: [AuthorizationGuardService],
    data: { roles: [Roles.FavoursAdmin] }
  }
];

const transactionSummaryWaiverRoutes: Routes = [
  {
    path: 'waivers/transactions/:transactionid',
    component: SummaryComponent,
    canActivate: [AuthorizationGuardService],
    data: { roles: [Roles.WaiversAdmin] }
  }
];


const transactionSummaryFavorRoutes: Routes = [
  {
    path: 'favours/transactions/:transactionid',
    component: SummaryComponent,
    canActivate: [AuthorizationGuardService],
    data: { roles: [Roles.FavoursAdmin] }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(summaryWaiverRoutes),
    RouterModule.forChild(summaryFavorRoutes),
    RouterModule.forChild(transactionSummaryWaiverRoutes),
    RouterModule.forChild(transactionSummaryFavorRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SummaryRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/summary/summary-routing.module.ts